import {
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';

export default {
  async linkIssue(
    testExecutionStepId: string | number,
    linkedIssueId: string | number
  ): Promise<void> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants')
          .URL_TEST_EXECUTION_STEP_LINKED_ISSUE +
        '/' +
        testExecutionStepId +
        '/linkedIssues/' +
        linkedIssueId
    );

    await axios.post(
      url,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  },

  async unlinkIssue(
    testExecutionStepId: string | number,
    linkedIssueId: string | number
  ): Promise<void> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants')
          .URL_TEST_EXECUTION_STEP_LINKED_ISSUE +
        '/' +
        testExecutionStepId +
        '/linkedIssues/' +
        linkedIssueId
    );

    await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        testExecutionStepId,
        linkedIssueId,
      },
    });
  },
};
